export default "__VITE_ASSET__C$52Apem__"